// /frontend/src/pages/TermsPage.jsx
import React from 'react';
import Layout from '../components/layout/Layout';

const TermsPage = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 py-12">
        <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8">Terms of Service</h1>
        
        <div className="prose prose-lg max-w-none">
          {/* Important Notice */}
          <div className="bg-yellow-50 p-6 rounded-lg border border-yellow-200 mb-8">
            <p className="text-lg font-bold text-yellow-800 mb-2">Important Notice:</p>
            <p className="text-yellow-800">
              All Henderson Design Group products are sold through a purchase order (PO) system. We require a 3-month lead time for all installations. By placing an order with us, you acknowledge and agree to these terms.
            </p>
          </div>
          
          <p className="mb-6">
            These Terms of Service ("Terms") govern your use of the Henderson Design Group website and services, including the purchase of products, Design services, and Furniture Packages. By accessing our website or using our services, you agree to be bound by these Terms.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">1. Purchase Order System</h2>
          <p className="mb-4">
            Henderson Design Group operates exclusively on a purchase order (PO) system for all transactions. By placing an order with us, you agree to the following:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">All orders require a formal purchase order confirmation</li>
            <li className="mb-2">A 50% non-refundable deposit is required to initiate any order</li>
            <li className="mb-2">The remaining balance is due prior to delivery or installation</li>
            <li className="mb-2">Purchase orders are binding agreements and cannot be canceled once production has begun</li>
            <li className="mb-2">Any changes to purchase orders must be requested in writing and may result in additional fees and timeline adjustments</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">2. Lead Time and Installation</h2>
          <p className="mb-4">
            All products and services provided by Henderson Design Group require adequate lead time for sourcing, production, and installation:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">A minimum 3-month lead time is required for all installations</li>
            <li className="mb-2">This lead time begins from the date of final purchase order confirmation and deposit payment</li>
            <li className="mb-2">Specific delivery and installation dates will be scheduled once products are ready</li>
            <li className="mb-2">Henderson Design Group is not responsible for delays caused by manufacturers, shipping companies, or other third parties</li>
            <li className="mb-2">Installation appointments must be scheduled at least 2 weeks in advance</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">3. Pricing and Payment</h2>
          <p className="mb-4">
            All pricing and payment terms are as follows:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">All prices are quoted in USD and are subject to change without notice until a purchase order is confirmed</li>
            <li className="mb-2">A 50% non-refundable deposit is required to initiate any order</li>
            <li className="mb-2">The remaining balance is due before delivery or installation</li>
            <li className="mb-2">Design services require payment in full prior to beginning design work</li>
            <li className="mb-2">We accept credit cards, bank transfers, and checks as forms of payment</li>
            <li className="mb-2">Returned checks will incur a $35 fee</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">4. Design Services</h2>
          <p className="mb-4">
            For Design services, the following terms apply:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">All Design work begins after receipt of payment</li>
            <li className="mb-2">Designs are created specifically for the client and cannot be transferred or sold</li>
            <li className="mb-2">Henderson Design Group retains intellectual property rights to all designs created by our team</li>
            <li className="mb-2">We reserve the right to photograph completed projects for our portfolio</li>
            <li className="mb-2">Design revisions beyond the scope of the original agreement may incur additional fees</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">5. Delivery and Installation</h2>
          <p className="mb-4">
            For delivery and installation services:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Client must ensure adequate access to the installation location</li>
            <li className="mb-2">Client or authorized representative must be present during installation</li>
            <li className="mb-2">Henderson Design Group is not responsible for delays due to inaccessible installation locations</li>
            <li className="mb-2">Additional installation fees may apply for difficult access conditions</li>
            <li className="mb-2">Installation site must be prepared according to our specifications prior to installation date</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">6. Warranties and Returns</h2>
          <p className="mb-4">
            Our warranty and return policies are as follows:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li className="mb-2">Products are covered by manufacturer's warranties as specified on our Warranty page</li>
            <li className="mb-2">Custom orders, Furniture Packages, and personalized items cannot be returned unless there is a manufacturing defect</li>
            <li className="mb-2">Return eligibility and process are detailed on our Returns & Refunds page</li>
            <li className="mb-2">Henderson Design Group is not responsible for damages occurring after delivery and successful installation</li>
          </ul>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">7. Intellectual Property</h2>
          <p className="mb-6">
            All content on our website, including text, graphics, logos, images, and software, is the property of Henderson Design Group or its content suppliers and is protected by United States and international copyright laws. Unauthorized use of any materials may violate copyright, trademark, and other laws.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">8. Limitation of Liability</h2>
          <p className="mb-6">
            Henderson Design Group shall not be liable for any direct, indirect, incidental, special, consequential, or punitive damages resulting from the use or inability to use our services or products. In no event shall our liability exceed the amount paid by you for the product or service in question.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">9. Changes to Terms</h2>
          <p className="mb-6">
            Henderson Design Group reserves the right to modify these Terms at any time. Updated Terms will be posted on our website, and your continued use of our services after such changes constitutes your acceptance of the revised Terms.
          </p>
          
          <h2 className="text-2xl font-bold text-gray-800 mt-8 mb-4">10. Contact Information</h2>
          <p className="mb-6">
            If you have any questions regarding these Terms, please contact us at:
          </p>
          <p className="mb-6">
            <strong>Email:</strong> <a href="mailto:aloha@henderson.house" className="text-teal-700 hover:text-teal-900">aloha@henderson.house</a><br />
            <strong>Phone:</strong> <a href="tel:+18083158782" className="text-teal-700 hover:text-teal-900">808.315.8782</a><br />
            <strong>Address:</strong> 4343 Royal Place, Honolulu, HI 96816
          </p>
          
          <p className="mt-10 text-sm text-gray-500">
            Last updated: May 15, 2025
          </p>
        </div>
      </div>
    </Layout>
  );
};

export default TermsPage;